import React, { useState, useEffect } from "react";
import {
  Button,
  Modal, ModalHeader, ModalBody, ModalFooter,
} from "reactstrap";
import MapComponent from "../../../MapComponent";
import ApiCaller from "../../../../api/apiCaller";

interface SelectionElementItemProps {
    isShow?: boolean;
    siteId: number;
    onItemSelected?: Function;
}

const CompetitorSelectionModal = ({ isShow, siteId, onItemSelected }: SelectionElementItemProps) => {
    const [showSelectionModal, setShowSelectionModal] = useState<boolean | undefined>(isShow);
    const [siteData, setSiteData] = useState<any | null>({});

    const toogleSelectionModal = () => {
        setShowSelectionModal(!showSelectionModal);
    }
    const onMapItemPicked = (item:any) => {
        if (onItemSelected) {
            onItemSelected(item);
            setShowSelectionModal(false);
        }
    }
    const getSiteData = async () => {
        const uri = `site/${siteId}`;
        const res = await ApiCaller.get(uri);
        if (res?.result) {
            setSiteData(res?.result);
        }
    }
    useEffect(() => {
        getSiteData();
    }, []);
    return (
        <Modal size="lg" isOpen={showSelectionModal} toggle={toogleSelectionModal}>
            <ModalHeader toggle={toogleSelectionModal}>Chọn đối thủ để so sánh</ModalHeader>
            <ModalBody>
                <div style={styles.mapContainer}>
                    {siteData && siteData.latitude && siteData.longitude &&
                        <MapComponent
                            latitude={siteData.latitude}
                            longitude={siteData.longitude}
                            radius={2}
                            pickToSelectLocation
                            onItemPicked={(item:any) => onMapItemPicked(item)}
                        />
                    }
                </div>
            </ModalBody>
            <ModalFooter>
            <Button color="secondary" onClick={toogleSelectionModal}>Hủy</Button>
            </ModalFooter>
        </Modal>
    );
}

const styles = {
    mapContainer: {
        height: 500,
    },
}

export default CompetitorSelectionModal;